<template>
  <div class="carousel">
    <router-link tag="div" class="all" :to="url">
      {{ t('OUR') }} <br> {{ t(name) }}
      <img class="arrow" src="/modules/custom/vue_apps/assets/source/static/images/next.svg">
    </router-link>

    <carousel :autoplay="true" :autoplayTimeout="5000" :loop="true" :paginationEnabled="false">
      <slide v-for="item in items">
        <div :class="['slide', (item.link ? 'link' : '') ]" @click="click(item)">
          <img v-if="item.photo" :src="item.photo">
          <div v-if="item.name || item.post" class="body">
            <div class="name" v-if="item.name">{{ item.name }}</div>
            <div class="post" v-if="item.post">{{ item.post }}</div>
          </div>
        </div>
      </slide>
    </carousel>
  </div>
</template>

<script>
export default {
  props: [ 
    'url',
    'name',
    'items'
  ],

  methods: {
    click (item) {
      if (item.link) {
        window.open(item.link, '_blank');
      }
    }
  }
}
</script>

<style lang="scss">
.carousel {
  .slide {
    // background-position: center;
    // background-size: cover;
    margin: 0 auto;
    // display: flex;
    position: relative;
    width: 90%;
    //flex-direction: column;
    img {
      width: 100%;
      margin: 0 auto;
    }

    .body {
      position: absolute;
      bottom: 10px;
      left: 10px;
      .name {
        font-size: 21px;
      }
      .post {
        font-size: 12px;
      }
    }
  }

  .link {
    cursor: pointer;
  }
  * {
    font-family: 'Oswald', sans-serif;
  }


  .all {
    background-color: rgba(0, 0, 0, 0.3);
    width: 95%;
    padding: 12px;
    font-weight: 100;
    line-height: 18px;
    cursor: pointer;
    transition: background .3s ease;
    position: relative;
    margin: 0px auto 20px auto;

    .arrow {
      position: absolute;
      right: 10px;
      top: 0px;
      bottom: 0px;
      margin: auto;
      width: 20px;
    }
    &:hover {
      background-color: rgba(0, 0, 0, 0.55);
    }
    //padding: 10px;
  }

  .VueCarousel {
   // width: 90%;
    margin: 0 auto;
  }
}
</style>